import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import DataService from "../../../services/data.service";
import { IdProps } from '../../../types/IdProps';
import AddBrandEmployeePopup from '../Popups/Brand_popup_AddEmployee';

const Brand_tab_Employees: React.FC<IdProps> = ({ id }) => {
    const [data, setData] = useState<[]>();
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedFor } = useAuth();

    useEffect(() => {
        getTableData();
    }, [id]);

    function getTableData() {
        DataService.get<[]>('api/v1/BrandEmployees/ByBrand/' + id)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/BrandEmployees/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    let colInfos: IColInfo[] = [
        { key: true, dataProp: 'EmployeeId', visible: false },
        { title: 'Name', dataProp: 'employee.user', dataType: 'user', sort: 'asc' },
        { title: 'Workflow role', dataProp: 'functionalRole.name' }
    ];
    if (isAuthorizedFor(ApplicationFunctions.EditBrand)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }]
            });
    }

    return (
        <>
            <DataTable
                name='dtBrandEmployees'
                colInfos={colInfos}
                tableData={data}
                navigateTitle='Employee'
                navigateUrl='/plm/Employees/'
            />
            {showPopup && <AddBrandEmployeePopup show={showPopup} onHide={() => { setShowPopup(false); getTableData() }} brandId={id} />}
        </>
    );
}
export default Brand_tab_Employees;